import { useContext } from 'react';
import { DocumentSettingsContext } from '../DocumentSettings/DocumentDesignSettings/DocumentSettingsContext';
import { PageSetupView } from '../DocumentSettings/DocumentDesignSettings/PageSetupView';
import { SectionMarginSettings } from './SectionMarginSettings';
import { useSectionStylesUpdate } from 'components/editor/Sections/useSectionStylesUpdate';
import { useAppSelector } from '../../grid/reduxStore/Store.ts';
import { selectFirstSectionId } from '../../grid/reduxStore/editorSlice.ts';
import { DEFAULT_DOCUMENT_BACKGROUND_COLOR } from 'components/editor/shared/documentColorDefaults';
import PageOrientationSelect from '../DocumentSettings/PageOrientationSelect';
import { useOrientationChangeHandler } from 'components/editor/hooks/useOrientationChangeHandler';

export function SectionPageSetupSettings() {
  const sectionId = useAppSelector(selectFirstSectionId);
  const { currentStyles, updateStyles } = useSectionStylesUpdate(sectionId);
  const { sectionStyles, previewSectionBackgroundColor, captureSectionStyles, commitSectionBackgroundColor } =
    useContext(DocumentSettingsContext);

  const handleOrientationChange = useOrientationChangeHandler(currentStyles.pageOrientation, (orientation) => {
    updateStyles({ ...currentStyles, pageOrientation: orientation });
  });

  return (
    <PageSetupView
      backgroundColor={sectionStyles.backgroundColor ?? DEFAULT_DOCUMENT_BACKGROUND_COLOR}
      onColorChange={previewSectionBackgroundColor}
      onOpen={captureSectionStyles}
      onClose={commitSectionBackgroundColor}
      orientationSlot={<PageOrientationSelect value={currentStyles.pageOrientation ?? 'portrait'} onChange={handleOrientationChange} />}
      marginsSlot={<SectionMarginSettings styles={currentStyles} onUpdate={updateStyles} />}
    />
  );
}
